import "core-js/modules/es.array.push.js";
const __default__ = {
  name: "GroupsIndex",

  data() {
    return {
      showParticipantGroup: true,
      showStudentGroup: true,
      studentGroups: [],
      participantGroups: [],
      classroomGroups: [],
      filteredStudentGroups: [],
      filteredParticipantGroups: [],
      filteredClassroomGroups: [],
      filter: {
        keyword: "",
        classroom: false
      }
    };
  },

  computed: { ...mapState(["studentAddress"])
  },

  mounted() {
    const classroomGroups = this.groups.filter(v => v.type === "student" && v.class_id);
    const groupsByClassroom = [];
    this.classrooms.forEach(v => {
      if (classroomGroups.filter(g => g.class_id === v.id).length > 0) {
        groupsByClassroom.push(Object.assign({}, v, {
          group: classroomGroups.filter(g => g.class_id === v.id)
        }));
      }
    });
    this.filteredClassroomGroups = this.classroomGroups = groupsByClassroom;
    this.filteredStudentGroups = this.studentGroups = this.groups.filter(v => v.type === "student" && !v.class_id);
    this.filteredParticipantGroups = this.participantGroups = this.groups.filter(v => v.type === "participant");
    this.filteredStudentGroups = this.filteredStudentGroups.sort((a, b) => {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
    this.filteredParticipantGroups = this.filteredParticipantGroups.sort((a, b) => {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
  },

  methods: {
    filterList: function () {
      if (this.showStudentGroup) {
        const filteredClassroomGroups = [];
        this.classroomGroups.forEach(v => {
          if (this.filter.keyword) {
            const keywordMatched = v.group.find(v2 => {
              return v2.name.indexOf(this.filter.keyword) > -1;
            });

            if (keywordMatched) {
              const copy = Object.assign({}, v);
              copy.group = copy.group.filter(v2 => {
                return v2.name.indexOf(this.filter.keyword) > -1;
              });

              if (this.filter.classroom) {
                if (this.filter.classroom === v.id) {
                  filteredClassroomGroups.push(copy);
                }
              } else {
                filteredClassroomGroups.push(copy);
              }
            }
          } else {
            if (this.filter.classroom) {
              if (this.filter.classroom === v.id) {
                filteredClassroomGroups.push(v);
              }
            } else {
              filteredClassroomGroups.push(v);
            }
          }
        });
        this.filteredClassroomGroups = filteredClassroomGroups;

        if (this.filter.classroom) {
          this.filteredStudentGroups = [];
        } else {
          this.filteredStudentGroups = this.studentGroups.filter(v => {
            return v.name.indexOf(this.filter.keyword) > -1;
          });
        }
      } else {
        this.filteredClassroomGroups = [];
        this.filteredStudentGroups = [];
      }

      if (this.showParticipantGroup) {
        if (this.filter.classroom) {
          this.filteredParticipantGroups = [];
        } else {
          this.filteredParticipantGroups = this.participantGroups.filter(v => {
            return v.name.indexOf(this.filter.keyword) > -1;
          });
        }
      } else {
        this.filteredParticipantGroups = [];
      }
    }
  }
};
import { mapState } from "vuex";
import RowItem from "../RowItem"; // store

import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
import { useGroupStore } from "@/stores/group";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props, {
    expose
  }) {
    const {
      groups
    } = storeToRefs(useGroupStore());
    const {
      classrooms
    } = storeToRefs(useGradeClassroomStore());
    expose({
      groups,
      classrooms
    });
    return {
      __sfc: true,
      groups,
      classrooms,
      RowItem
    };
  }

});